import { getFragmentData } from '__generated__';
import { EntryCardsFragment } from '__generated__/graphql';
import { capitalize, toString } from '@liquorice/utils';
import { ARTICLE_CARD_FRAGMENT } from '../EntryCards/ArticleCard';
import { INSIGHT_CARD_FRAGMENT } from '../EntryCards/InsightCard';
import { SERVICE_CARD_FRAGMENT } from '../EntryCards/ServiceCard';
import { PROFILE_CARD_FRAGMENT } from '../EntryCards/ProfileCard';
import { OVERVIEW_CARD_FRAGMENT } from '../EntryCards/OverviewCard';
import { STANDARD_CARD_FRAGMENT } from '../EntryCards/StandardCard';

type EntryCards = EntryCardsFragment | null;

export const useEntryCards = (data: EntryCards) => {
  let fragment;
  let typeLabel = '';

  if (!data) return null;

  switch (data?.__typename) {
    case 'article_Entry':
      fragment = getFragmentData(ARTICLE_CARD_FRAGMENT, data);
      typeLabel = 'Article';
      break;
    case 'insight_Entry':
      fragment = getFragmentData(INSIGHT_CARD_FRAGMENT, data);
      typeLabel = 'Insight';
      break;
    case 'service_Entry':
      fragment = getFragmentData(SERVICE_CARD_FRAGMENT, data);
      typeLabel = capitalize(toString(fragment?.sectionHandle));
      break;
    case 'profile_Entry':
      fragment = getFragmentData(PROFILE_CARD_FRAGMENT, data);
      typeLabel = 'Profile';
      break;
    case 'overview_Entry':
      fragment = getFragmentData(OVERVIEW_CARD_FRAGMENT, data);
      typeLabel = 'Insight';
      break;
    case 'standard_Entry':
      fragment = getFragmentData(STANDARD_CARD_FRAGMENT, data);
      typeLabel = 'Insight';
      break;
    default:
      typeLabel = 'Page';
      break;
  }

  const typename = fragment?.__typename;

  return { fragment, typeLabel, typename };
};
